<template>
    <div>
        <div v-if="!loaded" class="enqContent d-flex align-items-center">
            <strong>{{ __('Loading...') }}</strong>
            <div class="spinner-border ml-auto" role="status" aria-hidden="true"></div>
        </div>

        <div v-else>
            <div class="alert alert-info show" role="alert" v-if="!disabled">
                <i class="fa fa-cogs mr-2"></i>{{ __('This enquiry will not be marked as lost until you have chosen a reason.') }}
            </div>

            <div class="enqContent"><i v-if="disabled" class="fragment-disabled"></i>
                <form autocomplete="off" role="form" class="form form-inline">
                    <div class="form-group align-items-center mb-3 w-100">
                        <label
                            for="lostReason"
                            class="d-block d-xl-none col-xs-12 control-label text-left my-1"
                        >
                            <strong>Lost Reason</strong>
                        </label>
                        <label
                            for="lostReason"
                            class="d-none d-xl-block col-xl-3 control-label text-right"
                        >
                            <strong>Lost Reason</strong>
                        </label>

                        <div class="col-xs-12 col-xl-9 w-100">
                            <select
                                v-model="lostReason"
                                id="lostReason"
                                class="form-control w-100 custom-select"
                                :disabled="disabled"
                            >
                                <option value="" disabled>{{ __('Please select.') }}</option>
                                <option
                                    v-for="reason in lostReasons"
                                    :key="reason.ID"
                                    :value="reason.ID"
                                    :disabled="selectableIDs[reason.ID]"
                                >{{ __(reason.reason) }}</option>
                            </select>
                        </div>
                    </div>

                    <div
                        class="offset-xs-0 offset-xl-3 col-xs-12 col-xl-9 d-flex align-items-center w-100"
                    >
                        <div class="d-inline-block col-xl-8 px-0">
                            <button
                                type="submit"
                                class="btn btn-primary"
                                :disabled="updating || disabled || '' === lostReason"
                                @click.prevent="onUpdate"
                            >Update</button>
                        </div>

                        <div class="d-flex align-items-center w-100" v-if="updating">
                            <strong class="ml-4">Updating...</strong>
                            <div class="spinner-border ml-auto" role="status" aria-hidden="true"></div>
                        </div>
                    </div>
                </form>
            </div>

            <div class="alert alert-primary show" role="alert" v-if="lostIsSource">
                <i class="fa fa-paper-plane text-primary mr-2"></i><a
                    :href="'mailto:' + encodeURIComponent(enquiry.company_contact.emailAddress) + '?subject=' + enquiry.id"
                >{{ __('Unable to Source? Send an email to :name', {'name': enquiry.company_contact.contactName}) }}</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "EnqFragmentLost",

    props: {
        enquiry: {
            required: true,
            type: Object,
        },

        disabled: {
            required: true,
            type: Boolean,
        },

        updateEnquiry: {
            required: true,
            type: Function,
        },
    },

    data() {
        return {
            loaded: false,
            updating: false,

            lostReasons: [],
            selectableReasons: [],

            lostReason: this.enquiry.lost ? this.enquiry.lost.reasonID : "",
            lostIsSource: this.enquiry.lost && 9 === this.enquiry.lost.reasonID,
        };
    },

    computed: {
        selectableIDs: function () {
            let ids = {};

            this.selectableReasons.forEach((reason) => {
                ids[reason.ID] = true;
            });

            return ids;
        },
    },

    methods: {
        onUpdate() {
            this.updating = true;

            axios
                .post("/api/enquiries/fragment/lost/update", {
                    enquiryID: this.enquiry.id,

                    lostReason: this.lostReason,
                })
                .then((response) => {
                    // console.log(response);
                    this.updating = false;

                    let data = response.data;
                    if (!data.success) {
                        if (data.errors) {
                            console.log(data.errors);
                        } else {
                            $("#fail-alert")
                                .text(data.message || "Unknown error")
                                .slideDown(500)
                                .delay(8000)
                                .slideUp(500);
                        }
                    } else {
                        if (9 === this.lostReason) {
                            this.lostIsSource = true;
                        } else if (11 === this.lostReason) {
                            location.assign(
                                "/enquiries/view/" +
                                    data.enquiry.next_revision.newEnquiryID +
                                    "/details"
                            );
                        }

                        this.updateEnquiry(data.enquiry);
                    }
                })
                .catch((error) => {
                    console.error(error.response);
                    this.updating = false;

                    $("#fail-alert")
                        .text(error.toString() || "Unknown error")
                        .slideDown(500)
                        .delay(8000)
                        .slideUp(500);
                });
        },
    },

    watch: {},

    mounted() {
        axios
            .post("/api/enquiries/fragment/lost/get", {
                enquiryID: this.enquiry.id,
            })
            .then((response) => {
                // console.log(response);

                let data = response.data;
                if (!data.success) {
                    $("#fail-alert")
                        .text(data.message || "Unknown error")
                        .slideDown(500)
                        .delay(5000)
                        .slideUp(500);
                } else {
                    this.loaded = true;
                    this.lostReasons = data.lostReasons;
                    this.selectableReasons = data.selectableReasons;
                }
            })
            .catch((error) => {
                console.error(error.response);

                $("#fail-alert")
                    .text(error.toString() || "Unknown error")
                    .slideDown(500)
                    .delay(5000)
                    .slideUp(500);
            });
    },
};
</script>
